<div class="layout-controls">
  <div class="layout-buttons">
    <ptl-button
      [highlighted]="currentLayoutView === 'CardView'"
      (click)="onLayoutViewChange('CardView')"
      [type]="'tertiary-neutral'"
      [size]="'m'"
      [icon]="LucideLayoutGrid"
    ></ptl-button>

    <ptl-button
      [highlighted]="currentLayoutView === 'SnakeView'"
      (click)="onLayoutViewChange('SnakeView')"
      [type]="'tertiary-neutral'"
      [size]="'m'"
      [icon]="LucideListEnd"
    ></ptl-button>

    <ptl-button
      [highlighted]="currentLayoutView === 'ListView'"
      (click)="onLayoutViewChange('ListView')"
      [type]="'tertiary-neutral'"
      [size]="'m'"
      [icon]="LucideTextAlignJustify"
    ></ptl-button>
  </div>
</div>
